var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4584 7.71289H34.501C34.501 11.4192 35.9733 14.9737 38.5941 17.5945C41.2148 20.2152 44.7693 21.6876 48.4756 21.6876H54.1784V27.1936C54.1834 34.9046 60.433 41.1544 68.144 41.1595V10.3984C68.144 8.91568 66.9419 7.71289 65.4584 7.71289Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1408 23.1377H19.1836C19.1884 30.8487 25.438 37.0985 33.1492 37.1035H38.8519V42.6272C38.8617 50.3382 45.1156 56.5838 52.8266 56.5838V25.8238C52.8266 24.3405 51.624 23.1377 50.1408 23.1377Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8139 38.5537H3.85645C3.85645 46.2717 10.1133 52.5284 17.8311 52.5284H23.5517V58.0342C23.5567 65.7381 29.7955 71.9852 37.4997 71.9998V41.2395C37.4997 39.7562 36.2971 38.5537 34.8139 38.5537Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/JIRA.a02ae569a0031130ee1750f92eb9b883.svg";
export { ForwardRef as ReactComponent };